// extracted by mini-css-extract-plugin
export default {"collectionTitle":"_413d01c7"};